module.exports = __webpack_public_path__ + "static/media/client-hub.cad1befc.png";